import { useMutation } from '@tanstack/react-query';
import { CALCULATIONS_MUTATION_KEY } from 'services/calculations/mutationKey';

import { PersonalExpensesApi } from '../personalExpenses.api';

export const useGetPersonalExpensesCalculationsOnCategory = () => {
  return useMutation({
    mutationKey: CALCULATIONS_MUTATION_KEY,
    mutationFn: PersonalExpensesApi.getPersonalExpensesCalculationsByCategory,
  });
};
